import React from "react"
import BaseIcon from "./BaseIcon"

const MinusIcon = ({ color, ...props }) => (
    <BaseIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11.5"
            cy="11.5"
            r="10.25"
            stroke={color ? color :"#27272D"}
            strokeWidth="1.5"
        />
        <path
            d="M4.79688 12.3647C9.11688 12.1247 14.1809 12.1247 18.4769 12.3647V10.6367C14.1809 10.8767 9.11688 10.8767 4.79688 10.6367V12.3647Z"
            fill={color ? color :"#27272D"}
        />
    </BaseIcon>
)

export default MinusIcon
